var list = [];

for(var i = 1; i <= 31; i++)
    list.push(`/images/RR${i}.JPG`);

export default list;